export default __webpack_public_path__ + "static/media/team-1.30c859cd.jpg";